import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { getPermissions } from '../services/api_permissions';
import Fetching from './fetching';

const PermissionsTable = ({ onChange, activePermissions }) => {
  const { token } = useContext(AuthContext);
  const [handlerPermissions, setHandlerPermissions] = useState([]);
  const [employeePermissions, setEmployeePermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true);
      try {
        const permissions = await getPermissions(token);
        const handlerPerms = permissions.filter(permission => permission.role === 'handler');
        const employeePerms = permissions.filter(permission => permission.role === 'employee');

        setHandlerPermissions(handlerPerms.map(permission => ({
          ...permission,
          isChecked: activePermissions.includes(permission.id),
        })));

        setEmployeePermissions(employeePerms.map(permission => ({
          ...permission,
          isChecked: activePermissions.includes(permission.id),
        })));
      } catch (error) {
        console.error("Errore durante il recupero dei permessi:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [token, activePermissions]);

  const handlePermissionToggle = (id, isChecked) => {
    onChange(id, isChecked);
  };

  if (loading) {
    return <Fetching />;
  }

  return (
    <div>
      {/* Sezione Gestori */}
      <fieldset>
        <legend className="text-base font-semibold text-indigo-800">GESTORE</legend>
        <div className="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200">
          {handlerPermissions.length > 0 ? (
            handlerPermissions.map((permission) => (
              <div key={permission.id} className="relative flex items-center py-2">
                <div className="min-w-0 flex-1 text-md font-normal text-gray-900 leading-6">
                  <div>{permission.name}</div>
                </div>
                <div className="ml-3 flex h-6 items-center">
                  <input
                    id={`handler-permission-${permission.id}`}
                    type="checkbox"
                    className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600 me-3"
                    checked={permission.isChecked || false}
                    onChange={(e) => handlePermissionToggle(permission.id, e.target.checked)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="text-gray-500">Nessuna autorizzazione disponibile per i gestori</div>
          )}
        </div>
      </fieldset>

      {/* Sezione Dipendenti */}
      <fieldset className="mt-8">
        <legend className="text-base font-semibold text-indigo-800">DIPENDENTE</legend>
        <div className="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200">
          {employeePermissions.length > 0 ? (
            employeePermissions.map((permission) => (
              <div key={permission.id} className="relative flex items-center py-2">
                <div className="min-w-0 flex-1 text-md font-normal text-gray-900 leading-6">
                  <div>{permission.name}</div>
                </div>
                <div className="ml-3 flex h-6 items-center">
                  <input
                    id={`employee-permission-${permission.id}`}
                    type="checkbox"
                    className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600 me-3"
                    checked={permission.isChecked || false}
                    onChange={(e) => handlePermissionToggle(permission.id, e.target.checked)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="text-gray-500">Nessuna autorizzazione disponibile per i dipendenti</div>
          )}
        </div>
      </fieldset>
    </div>
  );
};

export default PermissionsTable;
